/* eslint-disable no-param-reassign */
import { ColumnItemElement, DreamBlock } from '@typedream/core';
import { getNodeParent } from '@udecode/plate-core';
import { DreamWithOverride } from '../../plate';
import { ELEMENT_COLUMN_ITEM } from '../../pluginKeys';
import { normalizeColumnItem } from './normalizers/normalizeColumnItem';

export const withColumnItem: DreamWithOverride = (editor) => {
  const { normalizeNode, getDirtyPaths } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    if (
      node.type === ELEMENT_COLUMN_ITEM
      && normalizeColumnItem(editor, [node as ColumnItemElement, path])
    ) {
      return;
    }

    normalizeNode(entry);
  };

  editor.getDirtyPaths = (op) => {
    const dirtyPaths = getDirtyPaths(op);

    // when moving column item child, mark the column path as dirty
    if (op.type === 'move_node') {
      const parent = getNodeParent<DreamBlock>(editor, op.path);
      if (parent?.type === ELEMENT_COLUMN_ITEM) {
        dirtyPaths.push(op.path.slice(0, -2));
      }
    }

    return dirtyPaths;
  };

  return editor;
};
